import React from 'react';
import PropTypes from 'prop-types';
import './AccordionSubSection.scss';

const AccordionSubSection = (props) => {
  const { children, title } = props;

  return (
    <div className="accordion-sub-section">
      <div className="accordion-sub-section-header">
        <strong>
          {title}
        </strong>
      </div>
      {children}
    </div>
  );
};

AccordionSubSection.defaultProps = {
  children: null,
};

AccordionSubSection.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default AccordionSubSection;
